import React from 'react';
import { Alert } from '@ver-uds/uswds-react';
import { Button } from '@ver-uds/react';
import { useLogout } from '@vis-auth/react';
import AlertConstants from '../../../constants/AlertConstants';
import EnrollmentContent from '../../../pages/Enrollment/utils/EnrollmentContent';

const EnrollmentPending = (): JSX.Element => {
  const logout = useLogout();

  return (
    <div className="tablet:grid-col-12 desktop:grid-col-9" data-testid="enrollment-pending-context">
      <h1>Enrollment Pending</h1>
      <Alert className="margin-y-3" status="warning" slim>
        <Alert.Text>{AlertConstants.ENROLLMENT_PENDING_GENERAL}</Alert.Text>
      </Alert>
      {EnrollmentContent.pendingIntroText}
      <Button className="margin-0" type="button" variant="primary" onClick={logout}>
        Log out of E-Verify
      </Button>
    </div>
  );
};

export default EnrollmentPending;
